<template>
 <div>
    <h3>Мы полностью соблюдаем законодательство РФ. Со всеми документами вы можете ознакомиться заранее:</h3>
          <div>
            <p>
              <a target="_blank" href="https://finmoll.ru/backend/content/documents/rules_microloans" class=txtLink>Правила
                предоставления микрозаймов
              </a>
            </p>
            <p>
              <a target="_blank" href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions" class=txtLink>Общие
                условия договора микрозайма
              </a>
            </p>
            <p>
              <a target="_blank"
                 href="https://finmoll.ru/backend/content/documents/microloan_providing_info" class=txtLink>Информация об условиях предоставления, использования и возврата потребительского займа
              </a>
            </p>
            <p>
              <a target="_blank"
                  href="/admd/pdf/informaciyaDlyaPoluchatelejFinansovojUslugi.pdf" class=txtLink>Информация для получателей финансовой услуги
              </a>
            </p>
          </div>
 </div>
</template>

<script>
export default {
  name: 'txtTerms'
}
</script>

<style scoped>
h3{margin-bottom: var(--font-size-15);font-size: var(--font-size-18);}
a.txtLink {margin-bottom: var(--font-size-10);}
</style>